var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_vm._v(" 🏠 "+_vm._s(_vm.$t('footer.home'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }